export class SoPlantRequest {
    saleOrderId: number;
    plantId:number;
   
    constructor(saleOrderId: number,plantId:number){
        this.saleOrderId = saleOrderId;
        this.plantId = plantId;       
    }
}
